import {APIResponse, easasAxios} from "../services/HttpService";
import {AxiosInstance} from 'axios'
import {DatasetDataLagLeadRequest, UpdateDatasetData} from "./model/requests";
import {DatasetDataInfoOptions, DatasetDataInfoResponse} from "./model/dataset/DatasetDataInfoResponse";
import {IUsersDataInfoResponse} from "./model/user/UsersDataInfoResponse";
import {ILicenseDataInfo} from "./model/user/ILicenseDataInfo";

const API_SCOPE = "/datasetData";

export class DatasetDataApiDefinition {
    private httpClient: AxiosInstance;

    constructor(axiosInstance?: AxiosInstance) {
        console.log("DatasetDataApi obj created!")
        this.httpClient = axiosInstance ?? easasAxios; // Get default axios if not defined
    }

    async getDataInfo(identifiers: Array<string>, config?: DatasetDataLagLeadRequest): Promise<APIResponse<Array<DatasetDataInfoResponse>>> {
        try {
            const {data} = await this.httpClient.post(`/dashboard/datasets/dataInfo`, {...config, identifiers});
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getRecentData(identifiers: string[], options?: DatasetDataInfoOptions): Promise<APIResponse<DatasetDataInfoResponse[]>> {
        if (!identifiers.length || identifiers.every(identifier => identifier === null || identifier === undefined)) {
            return {data: []};
        }
        try {
            const {data} = await this.httpClient.post(`${API_SCOPE}/dataInfoRecent`, identifiers, {params: {...options}});
            return {data};
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async updateData(UpdateDatasetDataArray: Array<UpdateDatasetData>): Promise<APIResponse<Array<UpdateDatasetData>>> {
        try {
            const {data} = await this.httpClient.post(`${API_SCOPE}/update`, UpdateDatasetDataArray);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getDataInfoRange(identifiers: Array<string>, timeStart: string, timeEnd?: string): Promise<APIResponse<Array<DatasetDataInfoResponse>>> {
        try {
            //Add 1 seconds to timeEnd time, to get the last datapoint
            let timeEndTemp = timeEnd ? timeEnd : timeStart;
            let timeEndPlusOneS = (new Date((new Date(timeEndTemp)).setSeconds(1))).toISOString()
            const {data} = await this.httpClient.post(`${API_SCOPE}/dataInfoRange?from=` + timeStart + `&to=` + timeEndPlusOneS, identifiers);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getUsers(permission?: string) {
        try {
            let props: string = "/users";
            if (permission) {
                props = props + "?hasPermission=" + permission;
            }
            const {data} = await this.httpClient.get<Array<IUsersDataInfoResponse>>(props);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getLicenses() {
        try {
            const {data} = await this.httpClient.get<Array<ILicenseDataInfo>>("/licences/licences")
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async clearDatasetData(queryData:{
        identifiers: Array<String>,
        timeStart: string,
        timeEnd: string,
        clearAll: boolean
    }) {
        try {
            this.httpClient.post(`${API_SCOPE}/clearData?from=` + queryData.timeStart + '&to=' + queryData.timeEnd + '&all=' + queryData.clearAll, queryData.identifiers);
            return {};
        } catch (error) {
            console.error(error);
            return {error};
        }
    }

}

export const DatasetDataApi = new DatasetDataApiDefinition();
